
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[storeSlug]/contactus",
      function () {
        return require("private-next-pages/store/[storeSlug]/contactus.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/[storeSlug]/contactus"])
      });
    }
  